// import './nav.less'

import { getLogoutUrl, accountProfileUrl, accountPasswordUrl, getUser } from '@npm/sso-auth'
import { useEffect, useRef, useState } from 'react'

import { Login } from './../login'
import { useIsPhone } from './hooks'
// import { aboutTags } from '../../pageContents/about/aboutTags'
import { industryList } from '../../pageContents/industry/industryList'
import { industryTags } from '../../pageContents/industry/industryTags'
import { productsList } from '../../pageContents/products/productsList'
import { solutionTags } from '../../pageContents/solution/solutionTags'
import { menus } from '../../pages/about/configs'
import { Pack } from '../pack'

type UserInfo = Awaited<ReturnType<typeof getUser>>

const Links = () => {
  return (
    <ul className='links'>
      <li>
        <a href='/products/'>产品中心</a>
        <ul className='hide'>
          {productsList.map(item => {
            return (
              <li key={`/products/${item.id}`}>
                <a href={`/products/${item.id}`}>{item.name}</a>
              </li>
            )
          })}
        </ul>
      </li>
      <li>
        <a href='/solution/'>解决方案</a>
        <ul className='hide'>
          {solutionTags.map(item => {
            return (
              <li key={`/solution/${item.id}`}>
                <a href={`/solution/${item.id}`}>{item.name}</a>
              </li>
            )
          })}
        </ul>
      </li>
      <li>
        <a href='/industry/'>应用案例</a>
        <div className='hide'>
          <div className='wrap'>
            {industryTags.map(item => {
              const { id, name } = item
              const url = `/industry/${id}`
              return (
                <div className='box' key={url}>
                  <h5>
                    <a href={url}>{name}</a>
                  </h5>
                  <ul>
                    {industryList.map(item => {
                      const { id, title, tag } = item
                      if (tag !== name) {
                        return null
                      }
                      const url = `/industry/${id}`
                      return (
                        <li key={url}>
                          <a href={url}>{title}</a>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
          </div>
        </div>
      </li>
      <li>
        <a href='/news/'>新闻资讯</a>
        {/* <ul className='hide'>
          <li>
            <a href='/news/company/'> 公司新闻 </a>
          </li>

          <li>
            <a href='/news/industry/'> 行业新闻 </a>
          </li>
        </ul> */}
      </li>
      <li>
        <a href='/about/'>关于我们</a>
        <ul className='hide'>
          {menus.map(item => {
            const { name, props } = item
            const { href, target, rel } = props
            const url = rel === 'noreferrer' ? href : `/about/${href}`
            return (
              <li key={href}>
                <a href={url} target={target}>
                  {name}
                </a>
              </li>
            )
          })}
        </ul>
      </li>
      <li>
        <a href='/tech-support'>技术支持</a>
      </li>
    </ul>
  )
}
// 透明导航名单
const testRegex = [
  // 新闻详情
  /^\/news\/[a-fA-F0-9]{24}$/,
  // 应用案例详情
  /^\/industry\/\d+-\d+\.html$/,
  /^\/member/,
  /^\/cP6mU6kW/
]
export const Nav = () => {
  const isLogin = useRef(false)
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null)

  // 导航占位
  const [show, setShow] = useState(false)
  // 是否为导航为透明
  const isAddHover = useRef(false)
  const isPhone = useIsPhone()

  useEffect(() => {
    if (testRegex.some(item => item.test(location.pathname)) || window.__IS_PAGE_ERROR__) {
      isAddHover.current = true
      console.log('当前页面导航为透明')
      setShow(true)
    }
    console.log('当前页面路径', location.pathname)
  }, [])

  useEffect(() => {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        if (isAddHover.current === true) {
          return
        }
        const targetEl = document.querySelector('.header-container')
        const bannerEl = document.querySelector(
          ['.public-banner-box', '.banner-box', '.nr_banner'].join(',')
        )! as HTMLDivElement | null
        const h = bannerEl !== null ? bannerEl.offsetHeight - 60 : window.innerHeight
        if (targetEl) {
          if (window.scrollY > h) {
            targetEl.classList.add('hover')
          } else {
            targetEl.classList.remove('hover')
          }
        }
      })
    })

    void getUser().then(res => {
      isLogin.current = true
      setUserInfo(res)
    })
  }, [])

  const [phoneNavOpened, setPhoneNavOpened] = useState(false)
  const containerClass = []
  if (isAddHover.current) {
    containerClass.push('hover')
  }
  return (
    <>
      <Pack className='header-container-placehold' if={show && !isPhone} />
      <Pack className={['header-container', ...containerClass].join(' ')} if={!isPhone}>
        <div className='inner-box'>
          <div className='logo'>
            <a href='/' title='' />
          </div>
          <Links />
          <ul className='others'>
            <li>
              <a className='kefu' href='/about/#contact'>
                联系销售
              </a>
            </li>
            <li>
              <a className='download' href='/member/download'>
                下载中心
              </a>
            </li>
            <li>
              <a className='download' href='/cP6mU6kW'>
                Download Center
              </a>
            </li>
            <li>
              <a className='shenqing' href='/member/licenses'>
                申请试用
              </a>
            </li>
            <Pack className='hover' if={userInfo !== null} tagName='li'>
              <div
                className='avatar'
                style={{
                  backgroundImage: `url(${userInfo?.avatar})`
                }}
              />
              <div className='hidden'>
                <ul>
                  <li>
                    <a className='license' href='/member/licenses'>
                      License申请
                    </a>
                  </li>
                  <li>
                    <a className='user' href={accountProfileUrl}>
                      个人信息
                    </a>
                  </li>
                  <li>
                    <a className='password' href={accountPasswordUrl}>
                      修改密码
                    </a>
                  </li>
                  <Pack if={userInfo?.type === 8}>
                    <li>
                      <a className='manage' href='/web-manage/news'>
                        网站管理
                      </a>
                    </li>
                  </Pack>
                  <li>
                    <a className='logout' href={getLogoutUrl({ auth_mode: 'modal' })} hrefLang='en'>
                      退出登录
                    </a>
                  </li>
                </ul>
              </div>
            </Pack>
            <Pack if={userInfo === null} tagName='li'>
              <button
                className='login-nav'
                onClick={() => {
                  window?.loginModal?.trigger()
                }}
              >
                登录/注册
              </button>
            </Pack>
          </ul>
        </div>
      </Pack>

      <Pack
        className='header-phone-mask'
        if={isPhone && phoneNavOpened}
        onClick={() => setPhoneNavOpened(false)}
      />
      <Pack className='header-phone-top' if={isPhone}>
        <a className='logo' href='/' title='' />
        <button className={`open-button`} onClick={() => setPhoneNavOpened(true)} />
      </Pack>

      <Pack className='header-phone-holder' if={isPhone} />
      <Pack className={`header-phone`} if={isPhone && phoneNavOpened}>
        <div className='top'>
          <a className='logo' href='/' title='' />
          <button className='close' onClick={() => setPhoneNavOpened(false)} />
        </div>
        <Links />
        <ul className='others'>
          <li className='download'>
            <a href='/member/download'>下载中心</a>
          </li>
          <li>
            <a href='/member/licenses'>申请试用</a>
          </li>
          <li className='kefu'>
            <a href='/about/#contact'>联系我们</a>
          </li>
        </ul>
        <Pack
          className='login-button'
          if={userInfo === null}
          onClick={() => {
            document.querySelector<HTMLButtonElement>('.close')?.click()
            window?.loginModal?.trigger()
          }}
        >
          登录/注册
        </Pack>
        <Pack className='bottom' if={userInfo !== null}>
          <div className='info'>
            <div
              className='avatar'
              style={{
                backgroundImage: `url(${userInfo?.avatar})`
              }}
            />
            <span>{userInfo?.account}</span>
          </div>
          <div className='more-info'>
            <div className='icon' />
            <div className='hidden'>
              <ul>
                <li>
                  <a className='user' href={accountProfileUrl}>
                    个人信息
                  </a>
                </li>
                <li>
                  <a className='password' href={accountPasswordUrl}>
                    修改密码
                  </a>
                </li>
                <li>
                  <a className='license' href='/member/licenses'>
                    License申请
                  </a>
                </li>
                <li>
                  <a className='license' href='/member/getlicenses'>
                    License申请记录
                  </a>
                </li>
                <Pack if={userInfo?.type === 8}>
                  <li>
                    <a className='manage' href='/web-manage/news'>
                      网站管理
                    </a>
                  </li>
                </Pack>
                <li>
                  <a className='logout' href={getLogoutUrl({ auth_mode: 'modal' })} hrefLang='en'>
                    退出登录
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Pack>
      </Pack>

      <Login />
    </>
  )
}
